import { useUserManagementContext } from '../context/UserManagementContext';
import {
  USER_MANAGEMENT_ORG_ADMIN_ACCESS,
  USER_MANAGEMENT_WRITE,
} from '../constants';

export function useUserManagementPermissions() {
  const { loggedInUserData } = useUserManagementContext();

  const userHasWritePermission = Boolean(
    loggedInUserData?.attributes.includes(USER_MANAGEMENT_WRITE),
  );
  const userHasOrgAdminAccess = Boolean(
    loggedInUserData?.attributes.includes(USER_MANAGEMENT_ORG_ADMIN_ACCESS),
  );

  return {
    canCreateUser: userHasWritePermission,
    canEditUser: userHasWritePermission || userHasOrgAdminAccess,
  };
}
